import {forkJoin, from, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

// FairPlay is probed with 'sinf'/'skd', NOT 'cenc'. Apple's key system does not
// support cenc init data, so a cenc probe is rejected on every Safari there is —
// which made FairPlay look unsupported and disabled previews on Safari outright,
// even though the player plays cbcs DASH there perfectly well.
//
// Both key system names are tried because Safari renamed it: 'com.apple.fps' is the
// modern one, 'com.apple.fps.1_0' the name older versions answer to. Either will do,
// so the probe succeeds if either does.
export const FAIRPLAY_KEY_SYSTEMS = ['com.apple.fps', 'com.apple.fps.1_0']
export const FAIRPLAY_CONFIG = [{
  'initDataTypes': ['sinf', 'skd'],
  'audioCapabilities': [{
    'contentType': 'audio/mp4;codecs="mp4a.40.2"'
  }],
  'videoCapabilities': [{
    'contentType': 'video/mp4;codecs="avc1.42E01E"'
  }]
}]

/** Emits once: whether this browser offers FairPlay under any of its key system names. */
export function fairPlaySupported(): Observable<boolean> {
  return forkJoin(FAIRPLAY_KEY_SYSTEMS.map(keySystem =>
    from(navigator.requestMediaKeySystemAccess(keySystem, FAIRPLAY_CONFIG as any))
      .pipe(map(() => true), catchError(() => of(false)))
  )).pipe(map(results => results.some(Boolean)))
}
